import { Component, OnInit } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { UntypedFormControl, Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { COUNTRIES_EN, COUNTRIES_FR, COUNTRIES_DE, COUNTRIES_ES } from 'src/assets/common/countries';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AddPhoto } from 'src/app/shared/constants/add-photo';
import { CustomStorageService } from 'src/app/services/custom-storage/custom-storage.service';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {
  countries_en = COUNTRIES_EN;
  countries_fr = COUNTRIES_FR;
  countries_de = COUNTRIES_DE;
  countries_esp = COUNTRIES_ES;
  employee: any;
  croppedImage: any = '';
  imageChangedEvent: any = '';
  croppedImageFile: any;
  tempCroppedImage: any;
  successMessage: any;
  tempCroppedImageFile: any;
  displayedImage: any = '../assets/images/user.svg';
  isSubmitted = false;
  isEmailUsed = false;
  isUsernameUsed = false;
  user: any;
  maxBirthdate: Date;
  editUserForm: UntypedFormGroup;
  loadingSpinner = false;
  idUser: string;
  email = new UntypedFormControl('', [Validators.required, Validators.email]);
  username = new UntypedFormControl('', [Validators.required, Validators.minLength(6)]);
  countries: any;
  langueStorage: any;
  showButtonEditPhoto = false;
  birthDate: any;
  dateBirth: any;
  addPhoto = new AddPhoto();
  mode;
  genders;
  typesUser;
  languages;

  constructor(
    private readonly constantService: ConstantService,
    private readonly translate: TranslateService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly enterpriseService: EnterpriseService,
    private readonly storageService: CustomStorageService
  ) {
  }

  ngOnInit() {
    this.mode = this.storageService.getEnterprise().mode;
    this.genders = [
      { name: this.translate.instant('Male'), code: 'Male' },
      { name: this.translate.instant('Female'), code: 'Female' },
    ];

    this.typesUser = [
      { name: this.translate.instant('EnterpriseOfficer'), code: 'EnterpriseOfficer' },
      { name: this.translate.instant('Member'), code: this.mode === 'B2B' ? 'EnterpriseMember' : 'Member' },
    ];

    this.languages = [
      { name: this.translate.instant('allemand'), code: 'al' },
      { name: this.translate.instant('english'), code: 'en' },
      { name: this.translate.instant('espagnol'), code: 'es' },
      { name: this.translate.instant('french'), code: 'fr' },
    ];


    this.translateCountryOptions();
    this.getParamsUserData();
    this.initializeForm();
    this.loadingSpinner = false;
  }

  getParamsUserData() {
    this.activatedRoute.params.subscribe(async params => {
      this.activatedRoute.queryParams.subscribe(param => {
        this.idUser = param['id'];
      });
      this.user = this.enterpriseService.getUserById(this.idUser).subscribe(async data => {
        this.user = data.user;
        if (this.user.birthDate !== undefined) {
          this.getTimestampDate(this.user.birthdate);
        }
        this.editUserForm.get('email').setValue(data.user.email);
        this.editUserForm.get('username').setValue(data.user.username);
        if (this.user.photo) {
          this.displayedImage = this.user.photo;
        }
        if (this.user.birthdate) {
          this.initializeBirthdate(true);
        } else {
          this.initializeBirthdate(false);
        }
        this.editUserForm.controls.gender.setValue(this.genders.find(gender => gender.code === this.user.gender));
        this.editUserForm.controls.type.setValue(this.typesUser.find(type => type.code === this.user.type));
        this.editUserForm.controls.country.setValue(this.countries.find(country => country.code === this.user.country));
        this.editUserForm.controls.locale.setValue(this.languages.find(language => language.code === this.user.locale));
      });
    });
  }

  initializeForm() {
    this.editUserForm = this.formBuilder.group({
      email: this.email,
      username: this.username,
      firstName: [this.user.firstName],
      lastName: [this.user.lastName],
      gender: [this.user.gender],
      type: [this.user.type],
      birthdate: new UntypedFormControl(),
      locale: [this.user.local],
      address: [this.user.address],
      city: [this.user.city],
      zipCode: [this.user.zipCode],
      phoneNumber: [this.user.phoneNumber],
      country: [this.user.country],
      photo: [this.user.photo],
    });
  }

  translateCountryOptions() {
    this.langueStorage = localStorage.getItem('storage-language');
    switch (this.langueStorage) {
      case 'en':
        this.countries = COUNTRIES_EN;
        this.sortedCountries();
        break;
      case 'de':
        this.countries = COUNTRIES_DE;
        this.sortedCountries();
        break;
      case 'es':
        this.countries = COUNTRIES_ES;
        this.sortedCountries();
        break;
      default:
        this.countries = COUNTRIES_FR;
        this.sortedCountries();
        break;
    }
  }

  sortedCountries() {
    this.countries = this.countries.sort((n1, n2) => {
      if (n1.name > n2.name) {
        return 1;
      }
      if (n1.name < n2.name) {
        return -1;
      }
      return 0;
    });
  }

  initializeBirthdate(exist: boolean) {
    if (exist) {
      this.birthDate = new Date(this.user.birthdate);
      this.editUserForm.controls.birthdate.setValue(this.birthDate);
    } else {
      this.birthDate = new Date(moment().subtract(40, 'year').format('DD-MMM-YYYY'));
      this.editUserForm.controls.birthdate.setValue(this.birthDate);
    }
  }

  /**
   * function is called to edit employee.
   */
  editEmployee() {
    this.editUserForm.disable();
    this.isSubmitted = true;
    if (this.editUserForm.invalid) {
      return;
    }
    const formData = new FormData();
    for (const key of Object.keys(this.editUserForm.controls)) {
      if (key !== 'email' && key !== 'username') {
        if (this.editUserForm.get(key).value) {
          if (key !== 'photo') {
            if (key === 'type' || key === 'locale' || key === 'country' || key === 'gender') { formData.append(key, this.editUserForm.controls[key].value.code); }
            else { formData.append(key, this.editUserForm.controls[key].value); }
          }
        }
      }
    }
    if (this.croppedImageFile) {
      formData.append('photo', this.croppedImageFile);
    }
    this.loadingSpinner = true;
    this.enterpriseService.updateEmployee(this.user.id, formData)
      .subscribe(data => {
        this.loadingSpinner = false;
        this.constantService.showSuccessToast('toast.user_update_success');
        this.constantService.navigateToUsers('/list');
      }, error => {
        this.loadingSpinner = false;
        switch (error.status) {
          case 401:
            this.authService.logout();
            break;
          case 409:
            switch (error.error.cause) {
              case 'EMAIL':
                this.isEmailUsed = true;
                break;
              case 'USERNAME':
                this.isUsernameUsed = true;
                break;
              default:
                this.constantService.showErrorToast('toast.user_update_fail');
                break;
            }
        }
      });
    this.isEmailUsed = false;
    this.isUsernameUsed = false;
  }

  /**
   * function is called to change file image.
   */
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  /**
   * function is called to confirm image cropped
   */
  confirmImage() {
    if (this.tempCroppedImage) {
      this.displayedImage = this.tempCroppedImage;
      this.croppedImageFile = this.tempCroppedImageFile;
      this.constantService.showSuccessToast('toast.image_updated');
    }
  }

  /**
   * function is called to crop image user
   */
  imageCropped(event: ImageCroppedEvent) {
    this.tempCroppedImage = event.base64;
    this.tempCroppedImageFile = this.addPhoto.dataURItoBlob(this.tempCroppedImage);
    this.showButtonEditPhoto = true;

  }

  getTimestampDate(date) {
    const tee = date.substr(0, 10).split('-');
    const newDate = new Date(parseInt(tee[0], 10), parseInt(tee[1], 10) - 1, parseInt(tee[2], 10) + 1);
    this.dateBirth = newDate.getTime();
  }

}
